"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTCJoinedInfoCodeEnum = void 0;
var RTCJoinedInfoCodeEnum;
(function (RTCJoinedInfoCodeEnum) {
    /**
     * 成功
     */
    RTCJoinedInfoCodeEnum[RTCJoinedInfoCodeEnum["Success"] = 0] = "Success";
    /**
     * 失败
     */
    RTCJoinedInfoCodeEnum[RTCJoinedInfoCodeEnum["Failure"] = 1] = "Failure";
    /**
     * 重复加入
     */
    RTCJoinedInfoCodeEnum[RTCJoinedInfoCodeEnum["ReJoin"] = 2] = "ReJoin";
    /**
     * 无麦克风权限
     */
    RTCJoinedInfoCodeEnum[RTCJoinedInfoCodeEnum["NoMicroPermission"] = 3] = "NoMicroPermission";
})(RTCJoinedInfoCodeEnum = exports.RTCJoinedInfoCodeEnum || (exports.RTCJoinedInfoCodeEnum = {}));
//# sourceMappingURL=RTCJoinedInfo.js.map